import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedApproaches } from '../components/FailedApproaches';
import { UniqueMethod } from '../components/UniqueMethod';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferBlock } from '../components/OfferBlock';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
export function LandingPage() {
  return <main className="min-h-screen bg-white font-body text-[#5C4B3A] selection:bg-[#2D6A4F] selection:text-white" data-id="element-226">
      <HeroSection data-id="element-227" />
      <OpeningHook data-id="element-228" />
      <ProblemSection data-id="element-229" />
      <FailedApproaches data-id="element-230" />
      <UniqueMethod data-id="element-231" />
      <WhatYouGet data-id="element-232" />
      <WhoIsFor data-id="element-233" />
      <HowItWorks data-id="element-234" />
      <ProofSection data-id="element-235" />
      <FAQSection data-id="element-236" />
      <OfferBlock data-id="element-237" />
      <Footer data-id="element-238" />
      <StickyCTA data-id="element-239" />
    </main>;
}